export enum FormName {
  MAKE_PAYMENT = 'Make a payment',
  ADD_ECHECK_ACCOUNT = 'Add echeck account',
  EMAIL = 'e-mail',
  MOBILE = 'mobile',
}

export enum EventStep {
  FORM_START = 'form_start',
  FORM_SUBMIT = 'form_submit',
  FORM_ERROR = 'form_error',
}

export interface MakePaymentEventConfig {
  event: EventStep;
  name: FormName; // name of the form
  error_type?: string; // name of the error
  invoice_value?: number; // sum of invoices value
  invoice_count?: number; // number of invoices selected
  credits_value?: number; // sum of selected credits
  invoice_numbers?: number[]; // array with all invoices numbers selected
}

export interface OtpEventConfig {
  event: EventStep;
  name?: FormName;
  method?: string; // selected verification method
  error_type?: string;
}

export const GA_MAKE_PAYMENT_EVENTS = new Map<EventStep, MakePaymentEventConfig>();

GA_MAKE_PAYMENT_EVENTS.set(EventStep.FORM_START, {
  event: EventStep.FORM_START,
  name: FormName.MAKE_PAYMENT,
});

GA_MAKE_PAYMENT_EVENTS.set(EventStep.FORM_SUBMIT, {
  event: EventStep.FORM_SUBMIT,
  name: FormName.MAKE_PAYMENT,
});

GA_MAKE_PAYMENT_EVENTS.set(EventStep.FORM_ERROR, {
  event: EventStep.FORM_ERROR,
  name: FormName.MAKE_PAYMENT,
});

export const GA_OTP_EVENTS = new Map<EventStep, OtpEventConfig>();

GA_OTP_EVENTS.set(EventStep.FORM_ERROR, {
  event: EventStep.FORM_ERROR,
});

GA_OTP_EVENTS.set(EventStep.FORM_START, {
  event: EventStep.FORM_START,
});

GA_OTP_EVENTS.set(EventStep.FORM_SUBMIT, {
  event: EventStep.FORM_SUBMIT,
});
